import { ChevronDown } from "lucide-react";

export default function Hero({ onBookNow }) {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/19225277/pexels-photo-19225277.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-950/85 to-stone-950/20" />
      <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-7xl w-full px-6 md:px-10 pb-24 md:pb-32 pt-32 fade-up">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-amber-500/90 text-xs tracking-[0.3em] uppercase mb-6">
            <span className="h-px w-10 bg-amber-500/60" />
            Est. Studio · By Appointment
          </div>
          <h1
            data-testid="hero-title"
            className="font-display text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight text-stone-50 font-normal"
          >
            Sharp cuts.
            <br />
            <span className="italic text-amber-500">Cleaner</span> finish.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 text-stone-300 text-base md:text-lg max-w-xl leading-relaxed"
          >
            AndoozyCutzz is Andaz's private chair — precision haircuts, beard
            grooming and highlights delivered with an unhurried, tailored
            experience.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-book-btn"
              onClick={onBookNow}
              className="bg-amber-500 text-stone-950 px-8 py-4 text-sm font-medium tracking-widest uppercase hover:bg-amber-400 transition-colors duration-300"
            >
              Book Your Chair
            </button>
            <a
              href="#services"
              data-testid="hero-services-link"
              className="border border-amber-500/60 text-amber-500 px-8 py-4 text-sm font-medium tracking-widest uppercase hover:bg-amber-500/10 transition-colors duration-300"
            >
              View Services
            </a>
          </div>
        </div>

        {/* Meta strip */}
        <div className="mt-20 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-stone-800 pt-8">
          {[
            { k: "Chair", v: "Private studio · one client at a time" },
            { k: "Thu", v: "12:00 PM – 6:00 PM" },
            { k: "Fri", v: "3:00 PM – 8:00 PM" },
            { k: "Sat / Sun", v: "10:00 AM – 11:00 PM · +$10 after 8 PM" },
          ].map((item) => (
            <div key={item.k}>
              <div className="text-[10px] tracking-[0.3em] uppercase text-amber-500/70">
                {item.k}
              </div>
              <div className="mt-2 text-sm text-stone-300">{item.v}</div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#about"
        className="hidden md:flex absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-stone-500 hover:text-amber-500 transition-colors duration-300 animate-bounce"
        aria-label="Scroll down"
      >
        <ChevronDown size={20} />
      </a>
    </section>
  );
}
